var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.isMobileAndNL || _vm.hideContact ? '' : 'nav-contact-mobile'},[(_vm.isMobileAndNL || _vm.hideContact)?_c('div'):_c('router-link',{attrs:{"to":_vm.dynamicEntity.to}},[_vm._v(" "+_vm._s(_vm.dynamicEntity.text)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }